<template>
  <div class="OrderDeta" ref="OrderDeta">

    <div class="overflow" ref="overflow" >

      <div class="header">
        <div class="header-left">
          <p v-if="deta_json.status == 0">订单待支付</p>
          <p class="count" v-if="deta_json.status == 0"><van-count-down
              ref="countDown"
              :time="deta_json.expireTime"
              :auto-start="false"
              format="订单将在mm:ss后关闭 请及时支付"
          /></p>

          <p v-if="deta_json.status == 1">订单待服务</p>
          <p v-if="deta_json.status == 2">订单已完成</p>
          <p v-if="deta_json.status != 0">订单编号：{{ deta_json.orderNo }}</p>

        </div>
        <img v-if="deta_json.status == 0" src="../../../assets/Order/pay.png" alt="">
        <img v-if="deta_json.status != 0" src="../../../assets/Order/service.png" alt="">
      </div>

      <div class="main">

        <ul class="list_ul">
          <li>
<!--            <p class="list_name">{{ deta_json.productCategory }}</p>-->
            <p v-if="deta_json.productCategory == 0" class="list_name">体检套餐</p>
            <p v-if="deta_json.productCategory == 1" class="list_name">胃肠镜筛查</p>
            <p v-if="deta_json.productCategory == 2" class="list_name">整合式筛查</p>
            <p v-if="deta_json.productCategory == 3" class="list_name">锦医未</p>
            <div class="list_li_deta" @click="link_Deta()">
              <img :src="deta_json.thumbnail" alt="">
              <div class="list_item">
                <h2>{{ deta_json.productName }}</h2>
                <p class="list_item_p1">{{ deta_json.subhead }}</p>
                <p class="list_item_p2">{{ deta_json.productPrice != 0 ? "¥" + deta_json.productPrice : "卡支付" }}</p>
              </div>
            </div>
          </li>
        </ul>

        <div class="main_content">

<!--          <template v-if="(deta_json.status != 0 || deta_json.status != 4) && deta_json.isAppointment">-->
          <template v-if="deta_json.isAppointmentInfo">
            <div class="main_content_info">
              <div class="list_left">
                <p class="list_left_top">就诊人</p>
                <h2>{{ deta_json.name }}</h2>
                <p class="list_left_gender" v-if="deta_json.gender == 0" >女</p>
                <p class="list_left_gender" v-if="deta_json.gender == 1" >男</p>
              </div>
              <div class="list_right">
                <div class="list_right_li" v-if="deta_json.relationshipKey != 0" >
                  <span>
                    <p>与</p>
                    <p>本</p>
                    <p>人</p>
                    <p>关</p>
                    <p>系</p>
                  </span>
                  <p class="list_right_li_p">{{ deta_json.relationshipValue }}</p>
                </div>
                <mu-badge v-if="deta_json.relationshipKey == 0" content="本人" color="primary"></mu-badge>
                <div class="list_right_li">
            <span>
              <p>手</p>
              <p>机</p>
              <p>号</p>
            </span>
                  <p class="list_right_li_p">{{ deta_json.phoneNo }}</p>
                </div>
                <div class="list_right_li">
            <span>
              <p>身</p>
              <p>份</p>
              <p>证</p>
              <p>号</p>
            </span>
                  <p class="list_right_li_p">{{ deta_json.idCardNo }}</p>
                </div>
              </div>
            </div>
          </template>

          <template v-if="deta_json.appointments && deta_json.appointments.length != 0">
            <ul class="commodity">
              <li class="commodity_li" v-for="item in deta_json.appointments" :key="item.id">
                <div class="commodity_li_header">
<!--                  <p>{{ item.productCategory }}</p>-->
                  <p v-if="item.productCategory == 0">体检套餐</p>
                  <p v-if="item.productCategory == 1">胃肠道筛查套餐</p>
                  <p v-if="item.productCategory == 2">整合式筛查</p>
                  <p v-if="item.productCategory == 3">锦医未</p>

                  <p v-if="item.status == 0" class="warning">待确认</p>
                  <p v-if="item.status == 1" class="primary">待检查</p>
                  <p v-if="item.status == 2" class="success">已完成</p>
                  <p v-if="item.status == 3" class="danger">已失效</p>
                  <p v-if="item.status == 4" class="danger">已退款</p>
                </div>
                <ul class="commodity_li_ul">
                  <li>
                    <span>预约时间</span>
                    <p>{{ item.appointmentDate ? item.appointmentDate : item.appointmentStartDate + '至' + item.appointmentEndDate }}
                      <br/>
                      {{ item.appointmentTime }}</p>
                  </li>
                  <li>
                    <span>预约地点</span>
                    <p>{{ item.hospitalName }}（{{ item.address }}）</p>
                  </li>
                </ul>
                <div class="button" v-if="item.productCategory == 1 || item.productCategory == 2 || item.productCategory == 3">
                  <mu-button @click="link_plan(item.id,deta_json.productCategory,deta_json.status)" color="success">胃肠道准备</mu-button>
                </div>
              </li>
            </ul>
          </template>

          <template v-if="deta_json.orderItemList && deta_json.orderItemList.length != 0">
            <ul class="orderItem">
              <li v-for="(item,index) in deta_json.orderItemList" :key="index" >
                <p>{{ item.itemName }}</p>
                <p>{{ "￥" + item.itemPrice }}</p>
              </li>
            </ul>
          </template>

          <div class="number">
            <p class="number_header">订单信息</p>
            <ul class="number_ul">
              <li v-if="deta_json.orderNo">
                <span>订单编号：</span>
                <p>{{ deta_json.orderNo }}</p>
              </li>
              <li v-if="deta_json.createTime">
                <span>创建时间：</span>
                <p>{{ deta_json.createTime }}</p>
              </li>
              <li v-if="deta_json.payTime">
                <span>付款时间：</span>
                <p>{{ deta_json.payTime }}</p>
              </li>
              <li v-if="deta_json.transactionId">
                <span>微信交易号：</span>
                <p>{{ deta_json.transactionId }}</p>
              </li>
            </ul>
          </div>

        </div>

      </div>

    </div>

    <div class="footer" ref="footer" v-if="deta_json.status == 0" >
<!--      <p v-if="deta_json.status == 0 || deta_json.status == 4" >¥ {{ deta_json.productPrice }}</p>-->
<!--      <p v-if="deta_json.status != 0 && deta_json.status != 4">¥ {{ deta_json.actualPaymentAmount }}</p>-->
      <p>{{ deta_json.paymentAmount }}</p>
      <mu-button @click="pay_link()" round color="primary">立即支付</mu-button>
    </div>

    <div class="footer" ref="footer" v-if="deta_json.status == 1 && !deta_json.isAppointment " >
<!--      <p v-if="deta_json.status == 0 || deta_json.status == 4" >¥ {{ deta_json.productPrice }}</p>-->
<!--      <p v-if="deta_json.status != 0 && deta_json.status != 4">¥ {{ deta_json.actualPaymentAmount }}</p>-->
      <p>{{ deta_json.actualPaymentAmount }}</p>
      <mu-button @click="make_link()" round color="primary">立即预约</mu-button>
    </div>

    <div class="footer" ref="footer" v-if="deta_json.status == 4" >
<!--      <p v-if="deta_json.status == 0 || deta_json.status == 4" >¥ {{ deta_json.productPrice }}</p>-->
<!--      <p v-if="deta_json.status != 0 && deta_json.status != 4">¥ {{ deta_json.actualPaymentAmount }}</p>-->
      <p>{{ deta_json.actualPaymentAmount }}</p>
      <mu-button @click="del(deta_json.orderId)" round color="primary">删除订单</mu-button>
    </div>

  </div>
</template>

<script>

export default {
  name: "OrderDeta",
  data() {
    return{
      deta_json: {
        expireTime: null,
        appointments: []
      }
    }
  },
  watch:{
    '$store.state.wxapy'(newValue) {
      let pay = newValue;
      if(pay == 0) {

        this.$router.go(-1);

        this.$store.commit("setWxapy",null);
      }else if(pay == 1) {

        this.$router.go(-1);

        this.$store.commit("setWxapy",null);
      }else if(pay == 2) {

        this.$router.go(-1);

        this.$store.commit("setWxapy",null);
      }else {
        this.$store.commit("setWxapy",null);
      }
    }
  },
  created() {

  },
  mounted() {
    this.get_deta(this.$route.query.id);

    setTimeout(() => {
      // 滚动条
      if(this.$refs.footer) {
        // this.$refs.overflow.style.height = this.$refs.OrderDeta.clientHeight - this.$refs.footer.clientHeight + "px"
        this.$refs.overflow.style.paddingBottom= "60px";
      }
    },1000)

  },
  methods: {
    get_deta(y) {
      this.$get("order/detail",y,true)
        .then(res=> {
          if(res) {
            console.log(res.data);
            this.deta_json= res.data;
            if(this.deta_json.expireTime) {
              // 倒计时
              this.$nextTick(() => {
                this.$refs.countDown.start();
              })
            }
          }
        })
    },
    // 删除订单
    del(y) {
      this.$dialog.confirm({
        message: "是否删除此订单",
      })
          .then(() => {
            this.$del('order',y,true)
                .then(res => {
                  if(res) {
                    this.$router.push({
                      path: "/OrderList",
                      query: {
                        active: ''
                      }
                    })
                  }
                })
          })
          .catch(() => {
            // on cancel
          });
    },
    // 跳转商品详情
    link_Deta() {
      this.$router.push({
        path: "/Deta",
        query: {
          id: this.deta_json.productId
        }
      })
    },
    // 跳转胃肠道准备
    link_plan(e,z,s) {
      this.$router.push({
        path: "/StomachPlan",
        query: {
          id: e,
          productCategory: z,
          status: s
        }
      })
    },
    pay_link() {
      // TODO 调起微信支付
      console.log(this.deta_json);

      let obj= {};
      obj["orderNo"]= this.deta_json.orderNo;
      obj["prepayId"]= this.deta_json.prepayId;
      obj["productId"]= this.deta_json.productId;

      this.$post("order/pay",obj)
          .then(res => {
            if(res) {
              console.log(res);

              this.$wxPay(res.data);

            }
          })


      // this.$router.push({
      //   path: "/MakeSetMeal",
      //   query: {
      //     id: this.deta_json.productId,
      //     price: this.deta_json.productPrice,
      //     name: this.deta_json.productName,
      //     isMake: true,
      //     orderNo: this.deta_json.orderNo,
      //     prepayId: this.deta_json.prepayId
      //   }
      // })
    },
    make_link() {
      this.$router.push({
        path: "/MakeSetMeal",
        query: {
          id: this.deta_json.productId,
          // price: this.deta_json.productPrice,
          price: 0,
          name: this.deta_json.productName,
          isMake: false,
          orderNo: this.deta_json.orderNo,
          isMakeOrder: true
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
    @import "../../../style/My/Order/OrderDeta";
</style>
